// The bounds of the volume filter, in a leaf module of their own.
//
// They used to live in FilterVolumeRange.tsx, which imports the posFilters
// slice for SetVolumeRange. The slice now reads them while it is still being
// evaluated, to seed queryVariables, so keeping them in the component would
// close a cycle -- slice -> buildQueryVariables -> component -> slice -- and
// whichever module the bundler happened to start with would hit `const` in its
// temporal dead zone and throw at boot.
export const MIN_VOLUME_RANGE = 0;
export const MAX_VOLUME_RANGE = 1000;
